
import React, { useState, useEffect } from 'react';
import { Card, Nav, Navbar, Button, Form ,Tooltip} from 'react-bootstrap';
import { useHistory } from "react-router-dom";
//redux
import { useSelector, useDispatch } from 'react-redux';
import imgurl from '../assets/images/imgUrl';
import API from "../util";
import { apiUrl } from "../util/urls";

import Sibebar from '../component/Sidebar';
import swal from "sweetalert";
import axios from "axios";

import { setLoader, setUserTemplate } from '../redux/actions/userAction'

const QrCode = () => {
    const history = useHistory();
    const storeState = useSelector((state) => state)
    const userTemplate = useSelector((state) => state.programDetails.userTemplate)
    const dispatch = useDispatch();
    const userStoreState = useSelector((state) => state.user)
    const logoutClickHandler = () => {
        sessionStorage.clear()
        history.push('/')
    }
    const [count, setCount] = useState();
    const [QrArray, setQrArray] = useState([])
    const getQrCode = (type) => {
        dispatch(setLoader(true))
        // API.get(`qrcode/generate?count=` + count)
        if (type == 'code') {
        let url = apiUrl + `qrcode/generate?count=` + count
        axios({
            url: url,
            method: 'GET',
            responseType: 'blob',
            headers: { Authorization: sessionStorage.getItem("Authorization") },
        }).then((res) => {
            console.log(res)
            var FileSaver = require('file-saver');
            var blob = new Blob([res.data], { type: 'application/pdf' });
            FileSaver.saveAs(blob, "QRCode_" + new Date());
            dispatch(setLoader(false))
        })
        } else {
        API.get('qrcode/generatelist?count=' + count).then((res) => {
            console.log(res)
            setQrArray(res.data.data)
        })
        }
    }
    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
        Generate QR card function allows the user to download and print QR cards and associate them with the patient at the registration stage.
        </Tooltip>
    );
    return (
        <>
            <Sibebar open={true} />
            <div className="contentapp">
                <Navbar expand="lg">
                    <button type="button" id="sidebarCollapse" className="btn btn-info hammenu"><i data-v-c3854e32="" className="fas fa-bars"></i></button>
                    <Navbar.Brand className="navTitle" href="#home">COVID</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ml-auto">
                            <img className="avatar mr-2" src={imgurl.avatar.default} />
                            <div>
                                <span className="name">{userStoreState.userDetails.name}</span><br></br>
                                <span>{userStoreState.userDetails.email}</span>
                            </div>
                            <button className="btn btn-sign" onClick={logoutClickHandler}><i className="fas fa-sign-out-alt fa-2x pull-right"></i></button>

                        </Nav>

                    </Navbar.Collapse>
                </Navbar>
                <div className="smart-setup-wrapper" style={{ height: "calc(100vh - 60px)" }}>
                    <div className="row">
                        <div className="col-12">
                            <div className="form-wizard ">
                                <Card>
                                    <Card.Header className="cardBlueHeader" as="h5">Generate QR Code</Card.Header>
                                    {storeState.user.isEdit ?
                                        <Card.Body className="odkDiv" >
                                            <Form>
                                            <Form.Group controlId="formBasicEmail">
                                            {/* <Form.Label>Enter No of QR code to be generated</Form.Label> */}
                                            <Form.Control
                                                value={count}
                                                onChange={function (e) {
                                                // console.log(e.target.value)
                                                setCount(e.target.value)
                                                }}
                                                type="number"
                                                placeholder="Enter Number of QR Codes to be Generated" />
                                            </Form.Group>
                                        </Form>
                                        <Button className="mr-2" onClick={() => getQrCode('code')} variant="primary">Generate QR Code</Button>
                                        </Card.Body> : <p>Program not published</p>}
                                </Card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer">
                <div className="row">
                    <div className="col-6">
                        <p className="footext">Powered by  <img className="fooimg" src={imgurl.durelogo.default} /></p>  </div>
                    <div className="col-6">
                        <div className="widthMaxContent ml-auto pt-2">
                            <p className="footextcopy">Copyright © 2020. All rights reserved</p></div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default QrCode;